<template lang="html">
   
    <footer class="">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 footer-copyright">
                    <p class="mb-0">{{$t('footer.Copyright')}} {{currnetYear}} &#169; {{companyName}} | {{$t('footer.Allrightsreserved')}}.</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script lang="js">


  export default  {
    name: 'footer',
    props: [],
        mounted() {
            this.currnetYear = new Date().getFullYear();
            this.companyName = localStorage.getItem('companyName');
    },
    data () {
      return {
          currnetYear:'',companyName:null
      }
    },
    methods: {

    },
    computed: {

    }
}


</script>

<style scoped lang="scss">

    .text-start {
        text-align: left !important
    }
    .content {
        direction: ltr;
        flex: 1;
        max-width: 100vw;
        padding: 1.5rem 1.5rem .75rem;
        width: 100vw
    }
    .footer {
        background: #f2f2f5;
        direction: ltr;
        padding: 1rem .875rem;
        font-size: 13px;
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 284px;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }
    .text-muted {
        --bs-text-opacity: 1;
        color: #6c757d !important
    }
    .footer p a {
        font-size: 16px;
        text-decoration: none;
        margin-top: 7px;
        display: block;
    }
</style>
